<template>
  <iColumn :gap="getOptionValue(LayoutGap)" width="fill">
    <iRow
      v-for="featureText in featureTexts"
      :key="featureText"
      :gap="featureRowGap"
      vertical-align="middle"
      width="fill"
      wrap="nowrap"
    >
      <iIcon
        v-if="getOptionValue(Icon)"
        :icon="getOptionValue(Icon)"
        :name="getOptionValue(Icon)"
        :variant="getOptionValue(IconVariant)"
        :size="getOptionValue(IconSize)"
        disable-hover-effect
        :style-overrides="iconStyleOverrides"
      />
      <iText
        v-bind="fullTextOptionsAttributes"
        :style-overrides="fullTextOptionsAttributes.textStyleOverrides"
      >
        {{ featureText }}
      </iText>
    </iRow>
  </iColumn>
</template>

<script>
import {
  SubscriptionCardElementMixin,
} from "%/dynamic-component-editor/standard-components/subscription-card/subscription-card-element-mixin";
import { TextElementMixin } from "%/dynamic-component-editor/standard-elements/text-element/text-element-mixin";
import {
  SubscriptionPlanFeatureListMixin,
} from "%/dynamic-component-editor/standard-components/subscription-card/subscription-plan-feature-list-mixin";

export default {
  name: "BaseSubscriptionPlanFeatureList",
  mixins: [SubscriptionCardElementMixin, TextElementMixin, SubscriptionPlanFeatureListMixin],
};
</script>
